import React from 'react';
import PropTypes from 'prop-types';

import LogoIllustration from '../images/logo.svg';
import LogoWhiteIllustration from '../images/logo-white.svg';
import styles from './FooterBottomSection.module.scss';
import { Link } from 'gatsby';

export const LOGO_APPEARANCES = {
  DEFAULT: 'default',
  WHITE: 'white',
};

export const LOGO_BY_APPEARANCE = {
  [LOGO_APPEARANCES.DEFAULT]: LogoIllustration,
  [LOGO_APPEARANCES.WHITE]: LogoWhiteIllustration,
};

const Logo = ({ appearance, className }) => (
  <img
    alt="Company logo"
    src={LOGO_BY_APPEARANCE[appearance]}
    className={className}
    width={160}
  />
);

Logo.propTypes = {
  appearance: PropTypes.oneOf(Object.values(LOGO_APPEARANCES)),
  className: PropTypes.string,
};

Logo.defaultProps = {
  appearance: LOGO_APPEARANCES.DEFAULT,
  className: '',
};

export default Logo;
